<template>
    <div class="shareExperience">
        <!-- 4-5选项跳转 -->
        <div class="step_title">
            <p><span>Step 3 of 4:</span> Share Your Experience With Others</p>
             <el-progress :text-inside="true" :stroke-width="24" :percentage="75" status="success"></el-progress>
        </div>
         <p style="text-align: center;font-size:20px;color: #747474;line-height: 26px;">Please help us share your experience on Amazon. It’s really important for us and it will really help us to keep offering these amazing promotions to our preferred customers.</p>
        <div class="post-content">
            <div class="post-content-left">
                <div class="fusion-title">Your Comment</div>
                <div class="comment"><el-input type="textarea" v-model="remark" disabled></el-input></div>
                <el-button round v-clipboard:copy="remark" v-clipboard:success="onCopy" v-clipboard:error="onError"> Click to Copy</el-button>
            </div>
            <div class="post-content-right">
                <el-image :src="image" ></el-image>
                <a :href="url" target="_blank" @click="getStatus" class="reviewBtn">CLICK HERE TO POST YOUR AMAZON REVIEW</a>
            </div>
        </div>
        <h6>
            Once you share your experience, just click on the button below to confirm your shipping address and complete your request.
            If you have any problem leaving the review, please start live chat or contact: femirowax@hotmail.com.
        </h6>
        <el-button round class="step" @click="submitForm" disabled v-if="status == false">GO TO THE LAST STEP</el-button>
        <el-button round class="steps" @click="submitForm"  v-else>GO TO THE LAST STEP</el-button>
    </div>
</template>
<script>
// import {freeGiftOrderFour} from '../../../api/freeGift'
export default {
    data() {
        // 邮箱验证
        var email = (rule, value, callback) => {
            // 邮箱正则
            const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
            // 邮箱框value判断
            if (!value) {
                callback(new Error('邮箱不能为空'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的邮件格式'))
            } else {
                callback()
            }
        }
        return {
            ruleForm:{},
            remark:'',
            rules:{
                name: [
                   { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请填写地址', trigger: 'blur' }
                ],
                email: [
                    {required: true, validator: email, trigger: 'blur' }
                ],
            },
            src: '',
            desc:'',
            title:'',
            image:'',
            url:'',
            status:false,
            // disabledStatus:false
        }
    },
    methods:{
        submitForm() {
            // freeGiftOrderFour({
            //     address: this.ruleForm.address,
            //     amazonOrderId: this.ruleForm.amazonOrderId,
            //     email: this.ruleForm.email,
            //     name: this.ruleForm.name
            // }).then((res=>{
            //     if (res.data.code === 200) {
            //         this.$message.success(res.data.message);
            //         this.$router.push('/home/autoLoginFreeGift')
            //     }else if(res.data.code === 201){
            //         this.$router.push('/noOrderId')
            //     } else {
            //         this.$message(res.data.message);
            //     }
            // }))
            // /share-experience-4
            this.$router.push(
                {
                    path:'/share-experience-4',
                    query:{
                        address: this.ruleForm.address,
                        amazonOrderId: this.ruleForm.amazonOrderId,
                        email: this.ruleForm.email,
                        name:this.ruleForm.name,
                        remark:this.remark,
                        image:this.image,
                        url:this.url
                    }
                }
            )
        },
        // 状态记录
        getStatus(){
            this.status = true;
            // this.$store.state.status = true;
            sessionStorage.status = true;
        },
         // 复制成功
        onCopy(e){
            if(e.text){
                this.$message({
                    message: 'Copy success!',
                    type: 'success'
                });
            }
        },
        // 复制失败
        onError(){
            this.$message.error('复制失败');
        },
        // 点击发表评论
        // AmazonReview(){
        //     console.log(this.remark);
        // }
    },
    created(){
        this.ruleForm.address = this.$route.query.address;
        this.ruleForm.amazonOrderId = this.$route.query.amazonOrderId;
        this.ruleForm.email = this.$route.query.email;
        this.ruleForm.name = this.$route.query.name;
        this.remark = this.$route.query.remark;
        this.url = this.$route.query.url;
        this.image = this.$route.query.image;
        this.title = this.$route.query.title;
        if(sessionStorage.status){
            this.status = sessionStorage.status;
        }
    },
    destroyed(){
        sessionStorage.removeItem('status')
    },
    beforeRouteLeave(to,from,next){
      if(
          to.path == '/gift' || 
          to.path == '/warranty-activated' ||
          to.path == '/share-experience' ||
          to.path == 'share-experience-2' ||
          to.path == 'share-experience-3' ||
          to.path == 'share-experience-4'
          ){
            //缓存
          from.meta.keepAlive = true;
      }else{
            //不缓存
          from.meta.keepAlive = false ;
      }
      next()
  }
}
</script>
<style lang="less" scoped>
    .shareExperience{
        padding: 0px 30px;
        width: 70%;
        margin: 0 auto;
        padding-bottom: 70px;
        box-sizing: border-box;
       .step_title{
           margin-top: 20px;
           margin-bottom: 10px;
           p{
               font-size: 18px;
               color: #393838;
               line-height: 26px;
               margin-bottom: 10px;
               span{
                   color: #a099cb;
                   margin-right: 5px;
               }
           }
       }
       .post-content{
           display: flex;
        //    justify-content: space-around;
           margin-bottom: 30px;
           margin-top: 20px;
           .post-content-left{
            //    width: 215px;
               margin-right: 4%;
                width: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
               .fusion-title{
                   color: rgb(239, 129, 163);
                   font-size: 18px;
                   line-height: 26px;
                   font-weight: bold;
                   margin-bottom: 30px;
               }
               .comment{
                   width: 65%;
                   padding: 20px 100px;
                   background-color: #e2ebf2;
                   margin-top: 25px;
                //    box-sizing: border-box;
               }
                .el-button{
                    margin-top: 10px;
                }
           }
           .post-content-right{
               flex: 1;
               display: flex;
                flex-direction: column;
                align-items: center;
                .el-image{
                    height: 100px;
                    width: 100px;
                    margin-bottom: 10px;
                }
           }
           .el-card{
              width: 50%;
              margin-top: 20px;
           }
       }
       h6{
            font-weight: 100;
            line-height: 18px;
            letter-spacing: -0.5px;
            font-style: normal;
            color: #747474;
       }
       .el-button,
       .reviewBtn{
            background: #a099cb;
            color: #fff;
            padding: 13px 29px;
            font-size: 14px;
            box-sizing: border-box;
        }
        .reviewBtn{
            border-radius: 20px;
            cursor:pointer;
        }
        .el-button:hover,
        .reviewBtn:hover{
            background-color:#887ecc;
        }
        .step{
           background: #c0c0c0;
           margin-left: 45%;
       }
       .step:hover{
           background-color: #999;
       }
       .steps{
           margin-left: 45%;
           background: #a099cb;
           color: #fff;
       }
       .steps:hover{
            background-color:#887ecc;
       }
    }
</style>